export default {"src":"/_next/static/media/education.e4e7abef.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};